import { defineTokens } from '@chakra-ui/react';

/**
 * Начертания, которые действительно нужны продукту. Было девять, от `thin` до `black`;
 * `thin`, `extralight` и `light` не стояли ни на одном экране и существовали только как
 * приглашение: пока ступень в наборе, рано или поздно её кто-то возьмёт, и на сайте появится
 * десятый способ нарисовать подпись.
 *
 * Шкала кеглей (theme/text-styles.ts) пользуется четырьмя: 400, 500, 600, 700. Ещё два,
 * 800 и 900, остаются ради цифр игровых карточек — там это отдельный типографический регистр
 * (см. gameStatsSurface). Если понадобится седьмое, сначала стоит спросить, почему не хватило
 * шести.
 */
export const fontWeights = defineTokens.fontWeights({
  normal: {
    value: '400',
  },
  medium: {
    value: '500',
  },
  semibold: {
    value: '600',
  },
  bold: {
    value: '700',
  },
  extrabold: {
    value: '800',
  },
  black: {
    value: '900',
  },
});
